import { AiOutlinePartition } from 'react-icons/ai';
import { AiOutlineFundView } from 'react-icons/ai';
import { BsFillPeopleFill, BsTools } from 'react-icons/bs';
import { VscServerProcess } from 'react-icons/vsc';
import { FcInspection } from 'react-icons/fc';
import { MdApproval, MdDriveFolderUpload } from 'react-icons/md';
import { TbReport } from 'react-icons/tb';
import { TbGauge } from 'react-icons/tb';
import { GiHarborDock } from 'react-icons/gi';
import { GoTools } from 'react-icons/go';
import { MdRunningWithErrors } from 'react-icons/md';

import { TbBuildingWarehouse } from 'react-icons/tb';

import { CgCalendarToday } from 'react-icons/cg';
import { FaToolbox, FaUserCog } from 'react-icons/fa';

const tiles = [
  {
    sNo: 1,
    link: '/common/company_roles_responsibilities_listOfProcedures?documentType=clause10ListOfProcedure',
    isLink: true,
    icon: <MdDriveFolderUpload size="5rem" color="#003566" />,
    p: 'LIST OF',
    span: 'PROCEDURE',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/admin/masterlistofmachine?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <AiOutlinePartition size="5rem" color="#a12222" />,
    p: 'Master List Of',
    span: 'Machine',
    isIcon: true,
  },
  // {
  //   sNo: 2,
  //   link: '/admin/masterlistofdepartment?filter=createdAt',
  //   isLink: true,
  //   clauseNo: 4,
  //   p: 'Master List Of',
  //   span: 'Department',
  //   icon: <AiOutlineFundView size="5rem" color="#343a40" />,
  //   isIcon: true,
  // },
  {
    sNo: 3,
    link: '/common/masterlistofTools?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <MdRunningWithErrors size="5rem" color="#a12222" />,
    p: 'Master List Of',
    span: 'Tools',
    isIcon: true,
  },
  {
    sNo: 4,
    link: '/common/masterlistofToolsNewIcpl?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <GoTools size="5rem" color="#135089" />,
    p: 'Master List Of',
    span: 'Tools (New)',
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/common/masterListOfCriticalSparePart?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <TbBuildingWarehouse size="5rem" color="#a12222" />,
    p: 'Master List Of',
    span: 'Critical Spare Parts',
    isIcon: true,
  },
  {
    sNo: 20,
    link: '/common/preventiveMaintenancePlanTiles',
    isLink: true,
    clauseNo: 4,
    icon: <GiHarborDock size="5rem" color="#495057" />,
    p: 'Preventive ',
    span: 'Maintenance',
    isIcon: true,
  },
  {
    sNo: 20,
    link: '/common/toolPreventiveMaintenancePlanTiles',
    isLink: true,
    clauseNo: 4,
    icon: <BsTools size="5rem" color="#495057" />,
    p: 'Tool Preventive',
    span: 'Maintenance',
    isIcon: true,
  },
  {
    sNo: 20,
    link: '/common/toolPreventiveMaintenancePlanNewTiles',
    isLink: true,
    clauseNo: 4,
    icon: <BsTools size="5rem" color="#135089" />,
    p: 'Tool Preventive',
    span: 'Maintenance (New)',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/admin/manMachineMatrixList?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <FaUserCog size="5rem" color="#135089" />,
    p: 'Man Machine',
    span: 'Matrix',
    isIcon: true,
  },
  {
    sNo: 21,
    link: '/common/gauges/list',
    isLink: true,
    clauseNo: 4,
    icon: <TbGauge size="5rem" color="#a12222" />,
    p: 'Master List Of',
    span: 'Gauges',
    isIcon: true,
  },
  {
    sNo: 22,
    link: '/common/gaugeMaintenanceTiles',
    isLink: true,
    clauseNo: 4,
    icon: <FaToolbox size="5rem" color="#a12222" />,
    p: 'Gauge Maintenance',
    span: 'Plan',
    isIcon: true,
  },
  {
    sNo: 21,
    link: '/common/fixtures/list',
    isLink: true,
    clauseNo: 4,
    icon: <TbGauge size="5rem" color="#a12222" />,
    p: 'Master List Of',
    span: 'Fixtures',
    isIcon: true,
  },
];

export default tiles;
